import React, { useState, useEffect } from "react";
import Layout from "../../Components/Navigation/Layout";
import axios from "axios";
import SkeletonLoader from "../../Components/Loader";
import { FaEdit, FaSave, FaTimes, FaStore, FaEnvelope, FaCalendarAlt, FaQuoteLeft, FaCheckCircle } from "react-icons/fa";

const FormComponent = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const [formData, setFormData] = useState({
    Email: "", Message: "", Shop_Name: "", Rate_Date: "",
    item1: "", item2: "", item3: "", item4: "", item5: "", item6: "", item7: "",
    item1_Price: "", item2_Price: "", item3_Price: "", item4_Price: "",
    item5_Price: "", item6_Price: "", item7_Price: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const fetchData = async () => {
    const user = localStorage.getItem("user");
    if (!user) { setLoading(false); return; }
    const userData = JSON.parse(user);

    try {
      const response = await axios.get("/server/baos_function/getRates/" + userData.Email);
      const jewelRates = response.data.data;

      if (jewelRates && jewelRates.length > 0 && jewelRates[0].Jewel_Rate) {
        const r = jewelRates[0].Jewel_Rate;
        setFormData({
          Email: r.Email || userData.Email || "",
          Message: r.Message || "",
          Shop_Name: r.Shop_Name || userData.Shop_Name || "",
          Rate_Date: r.Rate_Date || "",
          item1: r.item1 || "", item2: r.item2 || "", item3: r.item3 || "",
          item4: r.item4 || "", item5: r.item5 || "", item6: r.item6 || "", item7: r.item7 || "",
          item1_Price: r.item1_Price || "", item2_Price: r.item2_Price || "",
          item3_Price: r.item3_Price || "", item4_Price: r.item4_Price || "",
          item5_Price: r.item5_Price || "", item6_Price: r.item6_Price || "", item7_Price: r.item7_Price || "",
        });
        setId(r.ROWID);
      } else {
        setFormData((prev) => ({ ...prev, Email: userData.Email || "", Shop_Name: userData.Shop_Name || "" }));
      }
    } catch (error) {
      console.error(error);
      showToast("Error loading data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append("data", JSON.stringify(formData));
      const url = id ? `/server/baos_function/updateRate/${id}` : `/server/baos_function/addRate`;
      const response = await axios.post(url, form, { headers: { "Content-Type": "multipart/form-data" } });
      if (response.status === 200) {
        showToast("Rates updated successfully!");
        setIsEditing(false);
        if (!id && response.data.data.ROWID) setId(response.data.data.ROWID);
      }
    } catch (error) {
      showToast("Failed to update rates", "error");
    }
  };

  const formatDateForInput = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";
    const match = dateStr.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
    if (match) return `${match[3]}-${match[2]}-${match[1]}`;
    return dateStr;
  };

  if (loading) return <Layout><SkeletonLoader /></Layout>;

  return (
    <Layout>
      <style>{`
        .ar-container {
          height: calc(100vh - 120px);
          display: flex; flex-direction: column; gap: 12px;
          max-width: 1400px; margin: 0 auto; width: 100%; overflow: hidden;
          animation: ar-fade .5s ease;
        }
        @keyframes ar-fade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }

        .ar-hdr {
          background: #fff; border-radius: 12px; border: 1px solid #CBCBCB;
          padding: 16px 24px; display: flex; align-items: center; justify-content: space-between;
          box-shadow: 0 4px 12px rgba(0,0,0,0.03); flex-shrink: 0;
        }
        .ar-title-wrap { display: flex; flex-direction: column; }
        .ar-title { font-size: 16px; font-weight: 800; color: #0B2E33; display: flex; align-items: center; gap: 10px; }
        .ar-subtitle { font-size: 11px; color: #9ca3af; margin-top: 2px; }
        
        .ar-btns { display: flex; gap: 8px; }
        .ar-btn {
          padding: 8px 18px; border-radius: 10px; font-size: 13px; font-weight: 700;
          cursor: pointer; display: flex; align-items: center; gap: 8px; transition: all .2s; border: none;
        }
        .ar-btn-edit { background: #0B2E33; color: #B8E3E9; box-shadow: 0 4px 12px rgba(11,46,51,0.2); }
        .ar-btn-cancel { background: #F2F2F2; color: #931B5B; border: 1px solid #CBCBCB; }
        .ar-btn-save { background: linear-gradient(135deg, #931B5B, #6b1443); color: #fff; box-shadow: 0 4px 12px rgba(147,27,91,0.25); }
        .ar-btn:hover { opacity: 0.9; transform: translateY(-1px); }

        .ar-content {
          flex: 1; display: grid; grid-template-columns: 320px 1fr; gap: 16px; min-height: 0;
        }
        
        .ar-panel {
          background: #fff; border-radius: 12px; border: 1px solid #CBCBCB;
          padding: 20px; display: flex; flex-direction: column; gap: 16px; overflow-y: auto;
        }
        .ar-panel::-webkit-scrollbar { width: 4px; }
        .ar-panel::-webkit-scrollbar-thumb { background: #CBCBCB; border-radius: 10px; }

        .ar-fg { display: flex; flex-direction: column; gap: 6px; }
        .ar-lbl { font-size: 10px; font-weight: 800; color: #4F7C82; text-transform: uppercase; letter-spacing: 0.8px; }
        .ar-iw {
          display: flex; align-items: center; gap: 10px;
          border: 1.5px solid #F2F2F2; border-radius: 10px;
          padding: 10px 14px; background: #fafafa; transition: all .2s;
        }
        .ar-iw:focus-within { border-color: #0B2E33; background: #fff; box-shadow: 0 0 0 3px rgba(11,46,51,0.06); }
        .ar-ico { color: #CBCBCB; font-size: 14px; }
        .ar-inp { border: none; background: transparent; outline: none; font-size: 13.5px; color: #0B2E33; width: 100%; font-family: 'Inter', sans-serif; }
        .ar-inp:disabled { color: #9ca3af; cursor: not-allowed; }
        .ar-txt { border: none; background: transparent; outline: none; font-size: 13.5px; color: #0B2E33; width: 100%; min-height: 120px; resize: none; font-family: 'Inter', sans-serif; line-height: 1.5; }

        .ar-grid {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 12px; align-content: start;
        }
        .ar-item-card {
          background: #fff; border-radius: 12px; border: 1px solid #F2F2F2;
          padding: 14px; display: flex; flex-direction: column; gap: 10px;
          transition: all 0.25s ease;
        }
        .ar-item-card:hover { border-color: #CBCBCB; background: #fafafa; }
        .ar-item-label { font-size: 12px; font-weight: 700; color: #0B2E33; display: flex; align-items: center; justify-content: space-between; }
        .ar-item-inp-w { display: flex; align-items: center; background: #F2F2F2; border-radius: 8px; padding: 0 12px; border: 1px solid transparent; }
        .ar-item-card:focus-within .ar-item-inp-w { background: #fff; border-color: #0B2E33; }
        .ar-item-inp { flex: 1; border: none; background: transparent; outline: none; height: 38px; font-size: 15px; font-weight: 800; color: #0B2E33; text-align: right; }
        .ar-currency { font-size: 11px; font-weight: 600; color: #9ca3af; }

        .ut-toast {
          position:fixed;top:20px;right:22px;z-index:3000;
          padding:12px 20px;border-radius:12px;font-size:14px;font-weight:500;color:#fff;
          display:flex;align-items:center;gap:10px;animation:ar-fade .3s ease;
          box-shadow:0 8px 24px rgba(0,0,0,.15);
        }
        .ut-toast.success{background:linear-gradient(135deg,#0B2E33,#4F7C82);}
        .ut-toast.error{background:linear-gradient(135deg,#931B5B,#6b1443);}

        @media(max-width: 900px) {
          .ar-container { height: auto; overflow: visible; }
          .ar-content { grid-template-columns: 1fr; }
        }
      `}</style>

      {toast && <div className={`ut-toast ${toast.type}`}>{toast.type==="success"?"✅":"❌"} {toast.msg}</div>}

      <form className="ar-container" onSubmit={handleSubmit}>
        <header className="ar-hdr">
          <div className="ar-title-wrap">
            <h1 className="ar-title"><FaStore /> {formData.Shop_Name}</h1>
            <span className="ar-subtitle">Manage daily gold & silver rates for display</span>
          </div>
          <div className="ar-btns">
            {!isEditing ? (
              <button type="button" className="ar-btn ar-btn-edit" onClick={() => setIsEditing(true)}>
                <FaEdit /> Edit Rates
              </button>
            ) : (
              <>
                <button type="button" className="ar-btn ar-btn-cancel" onClick={() => setIsEditing(false)}>
                  <FaTimes /> Cancel
                </button>
                <button type="submit" className="ar-btn ar-btn-save">
                  <FaSave /> Save Changes
                </button>
              </>
            )}
          </div>
        </header>

        <main className="ar-content">
          <aside className="ar-panel">
            <div className="ar-fg">
              <label className="ar-lbl">Registered Email</label>
              <div className="ar-iw">
                <FaEnvelope className="ar-ico" />
                <input className="ar-inp" value={formData.Email} disabled />
              </div>
            </div>

            <div className="ar-fg">
              <label className="ar-lbl">Rate Effective Date</label>
              <div className="ar-iw">
                <FaCalendarAlt className="ar-ico" />
                <input className="ar-inp" type="date" name="Rate_Date" value={formatDateForInput(formData.Rate_Date)} onChange={handleChange} disabled={!isEditing} required />
              </div>
            </div>

            <div className="ar-fg" style={{ flex: 1 }}>
              <label className="ar-lbl">Display Message</label>
              <div className="ar-iw" style={{ height: '100%', alignItems: 'flex-start' }}>
                <FaQuoteLeft className="ar-ico" style={{ marginTop: 8 }} />
                <textarea className="ar-txt" name="Message" value={formData.Message} onChange={handleChange} disabled={!isEditing} placeholder="Enter message to display on board..." />
              </div>
            </div>
          </aside>

          <div className="ar-panel ar-grid">
            {[...Array(7)].map((_, i) => {
              const labelKey = `item${i + 1}`;
              const priceKey = `item${i + 1}_Price`;
              return (
                <div key={labelKey} className="ar-item-card">
                  <div className="ar-item-label">
                    {formData[labelKey] || `Item ${i + 1}`}
                    {!isEditing && formData[priceKey] && <FaCheckCircle style={{ color: '#10b981', fontSize: 10 }} />}
                  </div>
                  <div className="ar-item-inp-w">
                    <span className="ar-currency">₹</span>
                    <input className="ar-item-inp" type="text" name={priceKey} value={formData[priceKey]} onChange={handleChange} disabled={!isEditing} placeholder="0.00" required />
                  </div>
                </div>
              );
            })}
          </div>
        </main>
      </form>
    </Layout>
  );
};

export default FormComponent;
